export { LazyPill } from './LazyPill';
